<script>
import { mapActions } from "vuex";

export default {
  data() {
    return {
      firstName: "",
      surname: "",
    };
  },
  methods: {
    ...mapActions("settings", ["getUserToken", "postUserToken", "registerToken"]),
    getUserInfo() {
      let temp = window.location.search.split("?token=");
      this.token = temp[1];
      let params = {
        token: this.token,
      };
      this.getUserToken(params)
        .then((res) => {
          this.firstName = res.data[0].firstname;
          this.surname = res.data[0].surname;
        })
        .catch(({ response }) => {
          this.$toast.open({
            message: this.$parseResMessage(response.data.messageName),
            type: "error",
            duration: 5000,
            dismissible: true,
          });
        });
    },
    userToken() {
      const params = {
        token: window.location.search.split("?token="),
      }
      this.registerToken(params)
    },
    toLogin() {
      this.$router.push('/login')
    }
  },
  created() {
    this.getUserInfo();
  },
  watch: {},
};
</script>

<template>
  <div class="login-page">
    <div class="login-container">
      <div style="width: 65%">
        <div class="registerSingle-card" style="background-color: transparent">
          <img style="padding: 25px" src="/images/sustainfinity-logo.png" alt="sustainfinity-logo" />
          <div style="text-align: center">
            <p style="font-size: 200%; color: #61a60e">
              {{ $t("registerForm.hello") }} {{ this.firstName }}
              {{ this.surname }} !
            </p>
          </div>
          <div style="text-align: center">
            <p style="font-size: 200%; color: #61a60e">
              {{ $t("registerForm.email_verified") }}
            </p>
          </div>
          <button class="start-button" @click="toLogin()"> {{ $t("registerForm.to_login_button") }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<style>
.login-container {
  position: fixed;
  top: 50%;
  left: 75%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  width: 75vh;
  display: flex;
  flex-direction: column;
}

.registerSingle-card {
  border-radius: 5px;
  text-align: center;
  border: 2px solid rgb(214, 212, 212);
  width: 420px;
  min-height: 420px;
  display: flex;
  flex-direction: column;
  margin: auto;
  padding: 20px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
}


.start-button {
  display: block;
  width: 100%;
  background-color: #61a60e;
  color: white;
  padding: 0.5rem 1rem;
  border: none;
  border-radius: 0.25rem;
  text-align: center;
  cursor: pointer;
  font-weight: 600;
  text-transform: uppercase;
  font-size: 12px;
}

.start-button:hover {
  background-color: #229863;

}

.start-button:disabled {
  background-color: #6c757d;
  cursor: not-allowed;
  border: 1px solid #28a745;
}
</style>
